module.exports = __webpack_public_path__ + "static/climbing-142009f0e1351c551a5e2cee7d175054.jpg";